import { render, staticRenderFns } from "./LayoutAppBarVerticalNav.vue?vue&type=template&id=455820c6&scoped=true"
import script from "./LayoutAppBarVerticalNav.vue?vue&type=script&lang=js"
export * from "./LayoutAppBarVerticalNav.vue?vue&type=script&lang=js"
import style0 from "./LayoutAppBarVerticalNav.vue?vue&type=style&index=0&id=455820c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455820c6",
  null
  
)

export default component.exports